import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { EnumIroType, useListActivitiesQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'Activity',
  props: {
    filters: null
  },
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var props = __props;
    var headerConfig = {
      id: {
        sortable: true
      },
      name: {},
      industry: {},
      location: {},
      riskProfile: {},
      type: {}
    };
    var attrs = useAttrs();
    var headers = computed(function () {
      return attrs === null || attrs === void 0 ? void 0 : attrs.headers.map(function (h) {
        return _objectSpread(_objectSpread({
          value: h.value || h
        }, headerConfig[h.value || h]), _typeof(h) === 'object' && h !== null ? h : {});
      });
    });
    var options = ref({
      page: 1,
      itemsPerPage: 10,
      sortDesc: [true]
    });
    var search = ref('');
    var variables = computed(function () {
      return {
        filters: _objectSpread({}, props.filters),
        offset: options.value.itemsPerPage * (options.value.page - 1),
        limit: options.value.itemsPerPage
      };
    });
    var _useListActivitiesQue = useListActivitiesQuery(variables),
      result = _useListActivitiesQue.result,
      loading = _useListActivitiesQue.loading,
      refetch = _useListActivitiesQue.refetch;
    expose({
      refetch: refetch
    });
    var items = computed(function () {
      var _result$value;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listActivities;
    });
    var itemCount = computed(function () {
      var _result$value2;
      return (result === null || result === void 0 ? void 0 : (_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : _result$value2.countActivities) || 0;
    });
    return {
      __sfc: true,
      headerConfig: headerConfig,
      attrs: attrs,
      props: props,
      headers: headers,
      options: options,
      search: search,
      variables: variables,
      result: result,
      loading: loading,
      refetch: refetch,
      items: items,
      itemCount: itemCount,
      EnumIroType: EnumIroType
    };
  }
});